module.exports = __webpack_public_path__ + "img/waves-footer-2.0e4d191a.jpg";